/** IT translations for Les Aiguilles Blanches */
const it: Record<string, string> = {
  subtitle: "Simulazione Gatto delle Nevi",
  startGame: "Inizia",
  resumeGame: "Riprendi",
  newGame: "Nuova Partita",
  // UNUSED continue: "Continua",
  settings: "Impostazioni",
  controls: "Comandi",
  changelog: "Novità",
  howToPlay: "Come Giocare",
  howToPlayMove: "{keys} o Frecce per muoversi",
  howToPlayMoveHybrid: "{keys}/Frecce o D-pad touch",
  howToPlayGroom: "{groomKey} per preparare",
  howToPlayGroomHybrid: "{groomKey} o tieni il pulsante di preparazione",
  fullscreen: "Schermo intero",
  fullscreenHint: "Premi F per schermo intero",
  exitFullscreen: "Esci schermo intero",
  back: "Indietro",
  backToGame: "Torna al gioco",
  // UNUSED loading: "Caricamento...",
  inputKeyboard: "✓ Tastiera rilevata",
  inputKeyboardOff: "✗ Nessuna tastiera",
  inputTouch: "✓ Touchscreen rilevato",
  inputTouchOff: "✗ Nessun touchscreen rilevato",
  inputGamepad: "✓ Gamepad collegato",
  inputGamepadOff: "✗ Nessun gamepad",
  updateAvailable: "Nuova versione disponibile — tocca per ricaricare",
  madeIn: "Fatto con ❄️ in Savoia",
  feedback: "Invia feedback",
  on: "✓ SÌ",
  off: "✗ NO",
  zoneClosed: "🚫 ZONA CHIUSA",
  
  // Settings
  language: "Lingua",
  accessibility: "Accessibilità",
  highContrast: "Alto Contrasto",
  reducedMotion: "Meno Movimento",
  showFps: "Mostra FPS",
  showDebug: "Info di debug",
  skiStyle: "Stile",
  skiTricks: "Acrobazie",
  skiBestCombo: "Miglior combo",
  quitGame: "Esci dal gioco",
  display: "Schermo",
  displayWindowed: "Finestra",
  displayFullscreen: "Schermo intero",
  displayBorderless: "Senza bordi",
  colorblindMode: "Daltonismo",
  none: "Nessuno",
  deuteranopia: "Deuteran.",
  protanopia: "Protan.",
  tritanopia: "Tritan.",
  // UNUSED move: "Muovi",
  moveUp: "Su",
  moveDown: "Giù",
  moveLeft: "Sinistra",
  moveRight: "Destra",
  groom: "Battere",
  winch: "Verricello",
  pause: "Pausa",
  keyboard: "Tastiera",
  clickToRebind: "Clicca per modificare",
  pressKey: "Premi un tasto...",
  pressGamepadButton: "Premi un pulsante del gamepad...",
  noGamepad: "Nessun gamepad collegato",
  gamepadButtons: "Gamepad",
  saved: "Salvato!",
  resetControls: "Ripristina",
  controlsReset: "Comandi ripristinati!",
  movementSensitivity: "Sensibilità",
  keyboardLayout: "Layout tastiera",
  customBindings: "Personalizzato",
  // UNUSED gamepadSupported: "Gamepad OK",
  touch: "Touch",
  // UNUSED touchSupported: "Touch OK",
  noGamepadConnected: "Nessun gamepad connesso",
  gamepadDiagnostic: "Test controller",
  connectGamepadDiag: "Collega un controller per testare",
  gamepadDiagButtons: "Pulsanti",
  gamepadDiagSticks: "Levette",
  gamepadDiagTriggers: "Grilletti",

  // Audio
  audio: "Audio",
  masterVolume: "Volume principale",
  musicVolume: "Musica",
  sfxVolume: "Effetti sonori",
  engineVolume: "Motore",
  voiceVolume: "Voce",
  ambienceVolume: "Ambiente",
  mute: "Muto",

  backgroundAudio: "Audio in sottofondo",
  // Gameplay
  bonus: "Bonus",
  skiMode: "Modalità discesa",
  ski: "Sci",
  snowboard: "Snowboard",
  random: "Casuale",
  skiIt: "Sciare!",
  rideIt: "Snowboard!",
  skiAgain: "Ancora sci!",
  rideAgain: "Ancora snowboard!",
  skiRunSpeed: "Velocità",
  skiRunTime: "Tempo",
  skiRunGates: "Porte",
  
  // How to Play hints
  howToPlayMoveTouch: "Usa il D-pad virtuale",
  howToPlayMoveGamepad: "Stick o D-pad per muoversi",
  howToPlayGroomTouch: "Tieni il pulsante di preparazione",
  howToPlayGroomGamepad: "per preparare la neve",
  howToPlayFuel: "Controlla carburante e resistenza!",
  howToPlayWinch: "{winchKey} vicino a un palo per il verricello",
  howToPlayWinchTouch: "Tieni il pulsante verricello vicino a un palo",
  howToPlayWinchGamepad: "vicino a un palo per il verricello",
  howToPlayWinchHybrid: "{winchKey} o tieni il pulsante verricello vicino a un palo",
  
  // Winch
  winchSnapped: "💥 Cavo spezzato!",
  winchAttached: "🔗 Verricello agganciato! Tieni {winchKey} per assistenza.",
  winchActive: "VERRICELLO",
  // UNUSED winchHint: "Premi {winchKey} vicino a un paletto di ancoraggio numerato per il verricello",
  // UNUSED winchHintTouch: "Tieni 🔗 per il verricello",
  // UNUSED accessPath: "Strada di servizio",
  // UNUSED toPiste: "Verso la pista",
  
  // Game
  // UNUSED paused: "Pausa",
  resume: "Riprendi",
  quitToMenu: "Torna al Menu",
  levelComplete: "Pista completata!",
  levelFailed: "Pista fallita",
  tryAgain: "Riprova",
  coverage: "Copertura",
  time: "Tempo",
  // UNUSED target: "Obiettivo",
  // UNUSED rating: "Voto",
  nextLevel: "Prossima pista",
  // UNUSED replay: "Rigiocare",
  // UNUSED pressContinue: "Premi Spazio o tocca per continuare",
  pauseTitle: "⏸️ Pausa",
  restart: "Ricomincia",
  skipRun: "Salta discesa",
  newRun: "Nuova pista",
  quit: "Esci",
  menu: "Menu",
  levelSelect: "Mappa delle piste",
  locked: "Chiusa",
   completeToUnlock: "Completa {name} per sbloccare",
  tutorial: "Scuola di sci",
  timeUsed: "Tempo impiegato",
  excellent: "Eccellente!",
  good: "Ben fatto!",
  passed: "Superato",
  bonusFuel: "Carburante usato",
  bonusFlawless: "Primo tentativo",
  bonusSpeed: "Tempo",
  bonusWinch: "Usi del verricello",
  bonusExplore: "Strade esplorate",
  bonusPrecision: "Qualità della preparazione",
  retry: "Riprova",
  gameComplete: "Gioco completato!",
  viewCredits: "Vedi crediti",
  creditsTitle: "Complimenti!",
  creditsSubtitle: "Hai padroneggiato Les Aiguilles Blanches",
  creditsCreatedBy: "Creato da",
  creditsDevelopedWith: "Sviluppato con",
  creditsArtDirection: "Direzione Artistica",
  creditsRetroInspiration: "Un omaggio ai classici retrò come SkiFree",
  creditsInspiredBy: "Ispirato da",
  creditsGroomers: "I gattisti della Savoia",
  creditsDedication: "Per le squadre notturne che preparano le piste mentre dormiamo",
  creditsThanks: "Grazie per aver giocato!",
  creditsSeeYou: "A presto sulle piste!",
  creditsLine: "Dai, ragazzo. Il sole sorge. La montagna è pronta.",
  playAgain: "Rigiocare",
  skipCredits: "Premi un tasto per saltare",
  fr: "Francese",
  
  // Levels - Tutorial step by step
  tutorialName: "Tutorial - Primi Passi",
  tutorialTask: "Impara le basi",
  prologueLine: "Le 4 del mattino. La montagna è tua. Al lavoro.",
  prologueSkip: "Premi per continuare",
  tutorialIntro: "Benvenuto a Les Aiguilles Blanches!",
  skipTutorial: "⏭️ Saltando il tutorial… Tocca per rifarlo.",
  skipTutorialGamepad: "⏭️ Saltando il tutorial… Premi per rifarlo.",
  tutorialWelcome: "🏔️ Jean-Pierre, capo gattista. Vai sulla pista — usa {keys} o le frecce ↑↓←→.",
  tutorialWelcomeTouch: "🏔️ Jean-Pierre, capo gattista. Vai sulla pista — usa il D-pad a sinistra.",
  tutorialWelcomeGamepad: "🏔️ Jean-Pierre, capo gattista. Vai sulla pista — usa lo stick sinistro o il D-pad.",
  // UNUSED     tutorialControls: "🎮 Per muovere il gatto delle nevi, usa {keys} o le frecce ↑↓←→.",
  // UNUSED     tutorialControlsTouch: "🎮 Per muoverti, usa il D-pad ◀▲▼▶ a sinistra.",
  // UNUSED     tutorialControlsGamepad: "🎮 Per muoverti, usa lo stick sinistro o il D-pad.",
  // UNUSED     tutorialMove: "➡️ Dai, prova! Muoviti sulla pista — tutta la neve bianca va battuta.",
  // UNUSED     tutorialGroomIntro: "✅ Ottimo! Ora impariamo a battere la neve.",
  tutorialGroomAction: "❄️ Tieni {groomKey} mentre guidi per battere la neve. Vedrai, viene subito bella liscia!",
  tutorialGroomActionTouch: "❄️ Tieni il pulsante di preparazione a destra mentre guidi per battere la neve.",
  tutorialGroomActionGamepad: "❄️ Tieni {groomKey} mentre guidi per battere la neve. Vedrai, viene subito bella liscia!",
  tutorialGroomGoal: "📊 Ecco! Batti almeno il 60% prima dell'apertura. Gli sciatori arrivano!",
  // UNUSED   tutorialCoverage: "📊 Vedi? La neve diventa più liscia! Continua a battere!",
  // UNUSED   tutorialHUD: "📈 Guarda il cruscotto in alto: la barra rossa è il carburante, la verde la resistenza, la bianca è la copertura. Il tempo scorre!",
  // UNUSED   tutorialGoal: "🎯 Devi battere almeno il 60% della pista prima dell'apertura. Gli sciatori stanno arrivando!",
  // UNUSED tutorialFuel: "⛽ Attento, guidare consuma carburante. Durante le missioni, fai un salto alla stazione di servizio!",
  tutorialComplete: "🏆 Bravo! Hai imparato le basi. Pronto per la tua prima missione sulla Pista Verde?",
  level_marmottesName: "Pista Verde - Les Marmottes",
  level_marmottesTask: "Prepara la pista principianti",
  level_chamoisName: "Pista Blu - Le Chamois",
  level_chamoisTask: "Prepara prima dell'apertura",
  level_airZoneName: "Snowpark - Air Zone",
  level_airZoneTask: "Prepara i moduli freestyle",
  level_aigleName: "Pista Rossa - L'Aigle",
  level_aigleTask: "Terreno ripido, gestisci il carburante",
  level_glacierName: "Pista Rossa - Le Glacier",
  level_glacierTask: "Impara ad usare il verricello in pendenza",
  level_tubeName: "Halfpipe - Le Tube",
  level_tubeTask: "Prepara l'halfpipe per la gara",
  level_verticaleName: "Pista Nera - La Verticale",
  level_verticaleTask: "Operazione notturna con verricello",
  level_colDangereuxName: "Zona Valanghe - Col Dangereux",
  level_colDangereuxTask: "Prepara la zona ad alto rischio",
  level_tempeteName: "Tempesta - Recupero",
  level_tempeteTask: "Libera le piste dopo la tempesta",
  level_coupeDesAiguillesName: "Coupe des Aiguilles - Finale FIS",
  level_coupeDesAiguillesTask: "Prepara tutte le piste per la competizione",
  
  // Hazards
  cliffFall: "⚠️ ATTENZIONE! Sei caduto nel dirupo! Missione fallita.",
  fuelEmpty: "⛽ SERBATOIO VUOTO! Neanche una goccia di diesel...",
  // UNUSED avalancheZone: "ZONA VALANGHE",
  riskLevelHigh: "ALTO",
  avalancheWarning: "⚠️ PERICOLO! Manto nevoso instabile! Esci dalla zona!",
  avalancheTrigger: "🏔️💨 VALANGA INNESCATA! Impossibile evacuare!",
  steepWarning: "⚠️ PENDIO RIPIDO! Usa il verricello ({winchKey}) o scivolerai!",
  steepWarningNoWinch: "⚠️ PENDIO RIPIDO! Rallenta e usa le strade di servizio per aggirare!",
  tumble: "🔄 RIBALTAMENTO! Il gatto delle nevi si è rovesciato!",
  
  // Dialogues
  jeanPierreIntro: "Bravo per il tutorial, ragazzo. Ora si fa sul serio — la Verde, con cronometro e carburante da gestire.",
  level_marmottesMid: "Vedi quel bagliore sulle cime? La prima luce. Il bello di questo lavoro — solo tu, la macchina e la montagna che si sveglia.",
  level_chamoisIntro: "Ciao, sono Émilie — JP ti manda sulla blu. Dai, dimostra che sai fare di più che velluto sulla verde.",
  level_airZoneIntro: "Lo snowpark è il MIO territorio — prepareremo qualcosa di pazzesco! Ogni modulo dev'essere perfetto, i rider contano su di noi.",
  level_aigleIntro: "L'Aigle è roba seria. Occhio al carburante. I tracciati battipista permettono di risalire — cerca i pali a strisce gialle e nere.",
  level_glacierIntro: "Ciao, sono Thierry — responsabile sicurezza. Le Glacier è ripido. Ho controllato ogni ancoraggio. Premi {winchKey} vicino a un paletto per agganciare il verricello — e per favore, non mollare.",
  level_glacierIntroTouch: "Ciao, sono Thierry — responsabile sicurezza. Le Glacier è ripido. Ho controllato ogni ancoraggio. Tocca il pulsante verricello vicino a un paletto — e per favore, non mollare.",
  level_tubeIntro: "Domani c'è il contest al Tube! Voglio pareti pulite, labbro netto e zero gobbe.",
  level_verticaleIntro: "Notte su La Verticale: pendio ripido, bordi pericolosi. Verricello obbligatorio — agganciati ai 3 ancoraggi e resta in asse.",
  level_colDangereuxIntro: "Rischio valanga alto sul Col — siamo in protocollo sicurezza valanghe attivo. Stai fuori dalle zone cariche e rispetta i limiti.",
  level_tempeteIntro: "La tempesta è passata. Prendi un vin chaud, sarà lunga!",
  level_coupeDesAiguillesIntro: "È la grande notte. La FIS ispeziona domani. Ogni pista deve essere perfetta — mostrami cosa hai imparato.",
  marieWelcome: "Vieni a scaldarti da Marie. Una bella tartiflette!",
  marieIntro: "Ciao! Sono Marie, gestisco il ristorante in cima. Passa quando vuoi — un piatto caldo fa miracoli quassù!",
  
  // Changelog
  changelog_20260219_date: "19 febbraio 2026",
  changelog_20260219: "🎬 Prologo per nuovi giocatori\n📖 Tutorial semplificato\n🌦️ Meteo casuale nel menu\n🔗 Piste del giorno condivisibili\n🎥 Titoli di coda cinematografici",
  changelog_20260222_date: "22 febbraio 2026",
  changelog_20260222: "🚩 Ribilanciamento porte slalom\n💬 Pulsante feedback",
  changelog_20260223_date: "23 febbraio 2026",
  changelog_20260223: "📲 Installa sul tuo dispositivo per giocare offline",
  changelog_20260220_date: "20 febbraio 2026",
  changelog_20260220: "🗺️ Mappa delle piste\n🎿 Terminologia da stazione",
  changelog_20260217_date: "17 febbraio 2026",
  changelog_20260217: "🏔️ Sette forme di pista\n🎯 Varietà delle piste\n⚡ Discesa più fluida",
  changelog_20260216_date: "16 febbraio 2026",
  changelog_20260216: "🎲 Piste del giorno",
  changelog_20260215_date: "15 febbraio 2026",
  changelog_20260215: "⚡ Restyling rendering notturno\n📱 Pulsanti touch in sci\n⌨️ Rilevamento layout tastiera",
  changelog_20260214_date: "14 febbraio 2026",
  changelog_20260214: "🎪 Punti acrobazie e combo\n🏂 Posizione a uovo e fisica halfpipe\n👁️ Miglior contrasto delle piste\n📱 Battitura auto con verricello (touch)\n♿ Modalità alto contrasto",
  changelog_20260213_date: "13 febbraio 2026",
  changelog_20260213: "🚩 Porte di slalom\n🏔️ Salti con gli sci\n⚡ Prestazioni migliorate\n🎹 Musica notturna al pianoforte\n🔊 Volume motore regolabile",
  changelog_20260212_date: "12 febbraio 2026",
  changelog_20260212: "📋 Mappa delle piste\n🔗 Cavo verricello fragile\n🕹️ Diagnostica controller\n🍽️ I piatti di Marie\n❄️ Esposizione al freddo",
  changelog_20260211_date: "11 febbraio 2026",
changelog_20260211: "⛷️ Discesa sci dopo la preparazione\n🎯 Qualità della preparazione\n🏔️ Zone ripide colorate\n🏗️ Terrain park e trick",
  changelog_20260210_date: "10 febbraio 2026",
  changelog_20260210: "🎵 Musica ed effetti sonori\n🔈 Impostazioni volume\n⏱️ Tempi pista auto-calibrati\n⏭️ Salta il tutorial\n🏔️ Riprogettazione zone valanga",
  changelog_20260209_date: "9 febbraio 2026",
  changelog_20260209: "🏔️ Schermate vittoria/sconfitta alpine\n❄️ Accumulo neve da tempesta\n🏆 Bonus senza errori\n🔊 Suoni meteo e fauna",
  changelog_20260208_date: "8 febbraio 2026",
  changelog_20260208: "📊 Nuovo cruscotto\n🏔️ Le Glacier e Coupe des Aiguilles\n🦅 Fauna alpina\n🎨 Ritratti dei personaggi\n🎮 Navigazione tastiera e gamepad",
  changelog_20260207_date: "7 febbraio 2026",
  changelog_20260207: "🎨 UI retro\n🎯 Obiettivi bonus\n🕹️ Rimappatura tasti gamepad\n🎮 Navigazione gamepad",
  changelog_20260206_date: "6 febbraio 2026",
  changelog_20260206: "🛤️ Tracciati battipista percorribili\n🕹️ Joystick virtuale\n🌍 5 lingue complete",
  changelog_20260205_date: "5 febbraio 2026",
  changelog_20260205: "🏔️ Dirupi rocciosi\n🌙 Fari notturni\n🔗 Meccanica verricello\n⌨️ Navigazione tastiera",
  changelog_20260204_date: "4 febbraio 2026",
  changelog_20260204: "🎮 Supporto gamepad\n📱 Controlli touch\n💪 Resistenza\n💾 Salvataggio\n♿ Accessibilità",
  changelog_20260203_date: "3 febbraio 2026",
  changelog_20260203: "🚜 Lancio: 9 piste, scuola di sci\n❄️ Preparazione, carburante, valanghe\n🏆 Crediti e progressione",

  // Taunts - Cliff
  tauntCliff1: "9 tonnellate nel burrone. L'assicurazione sarà entusiasta.",
  tauntCliff2: "Jean-Pierre aveva detto: 'Non troppo vicino al bordo!' Ricordi?",
  tauntCliff3: "Il soccorso piste arriva con le corde. Di nuovo.",
  tauntCliff4: "Marie cancella la tua prenotazione per la raclette di stasera.",
  tauntCliff5: "Thierry sta già calcolando i costi di riparazione...",
  // Taunts - Fuel
  tauntFuel1: "L'indicatore era rosso da 10 minuti. Cosa guardavi?",
  tauntFuel2: "Émilie aveva scritto 'FARE RIFORNIMENTO' in maiuscolo.",
  tauntFuel3: "Anche il diesel ha i suoi limiti. Tu pure, a quanto pare.",
  tauntFuel4: "Jean-Pierre sospira. Manda Thierry con una tanica.",
  tauntFuel5: "Il sole sorge. La pista non è preparata. Gli sciatori stanno arrivando.",
  // Taunts - Time
  tauntTime1: "Prima seggiovia tra 3... 2... 1... Persa.",
  tauntTime2: "Gli sciatori scoprono la tua pista. Dissestata. Ghiacciata. Magnifica.",
  tauntTime3: "Jean-Pierre guarda l'orologio, poi te, poi di nuovo l'orologio.",
  tauntTime4: "La FIS chiede perché lo slalom è su una pappa.",
  tauntTime5: "Senti i maestri di sci spiegare ai clienti che 'non è colpa loro'.",
  // Taunts - Tumble
  tauntTumble1: "Il verricello non è decorativo. È per pendii come questo.",
  tauntTumble2: "Thierry fissa i danni. Non dice niente. È peggio.",
  tauntTumble3: "Jean-Pierre ti ha mostrato come ancorarti. Dormivi?",
  tauntTumble4: "Un PistenBully costa 400.000€. Beh, costava.",
  tauntTumble5: "Il pendio sembrava gestibile? Il gatto non era d'accordo.",
  featureDestroyedKicker: 'Sei passato sopra un modulo del park! Il kicker è distrutto.',
  featureDestroyedRail: 'Sei passato sopra un modulo del park! Il rail è distrutto.',
  tauntFeature1: 'Quel modulo ha richiesto tre ore. Tu l\'hai spianato in tre secondi.',
  tauntFeature2: 'Émilie avrà qualcosa da dirti su quel modulo del park.',
  tauntFeature3: 'Il team del park ti ha appena visto distruggere il loro capolavoro.',
  tauntFeature4: 'I moduli sono per gli sciatori, non per i gatti delle nevi. Gira intorno!',
  tauntFeature5: 'Un modulo in meno per la gara di domani.',
  bonusPipeMastery: 'Padronanza dell\'halfpipe',
  // Taunts - Avalanche
  tauntAvalanche1: "La montagna perdona raramente. Non ha perdonato.",
  tauntAvalanche2: "Météo France diceva rischio 4. L'hai letto?",
  tauntAvalanche3: "Il soccorso troverà il gatto in primavera. Forse.",
  tauntAvalanche4: "Marie sente l'allarme radio. Sa già che sei tu.",
  tauntAvalanche5: "Il soccorso piste aveva messo in sicurezza il settore. Tu l'hai rimesso in pericolo.",

  // Taunts - Ski wipeout (fun, self-deprecating)
  tauntSkiWipeout1: "Disastro totale. Attrezzatura ovunque, dignità da nessuna parte.",
  tauntSkiWipeout2: "Al dirupo non importava della tua tecnica sciistica.",
  tauntSkiWipeout3: "Il soccorso piste sta già ridendo. Hanno visto tutto.",
  tauntSkiWipeout4: "Ecco cosa succede a sciare sulla propria pista.",
  tauntSkiWipeout5: "Anche gli stambecchi hanno fatto una smorfia per quell'atterraggio.",
  // Key names
  key_space: "SPAZIO",
  key_shift: "MAIUSC",
  key_ctrl: "CTRL",
  key_alt: "ALT",
  key_enter: "INVIO",
  key_tab: "TAB",
  key_esc: "ESC",
  key_del: "CANC",
  dailyRuns: "Piste del giorno",
  dailyRuns_dailyShift: "Turno giornaliero",
  dailyRuns_randomRun: "Uscita casuale",
  dailyRuns_rank: "Grado",
  dailyRuns_seed: "Seme",
  // UNUSED   dailyRuns_start: "Avvia contratto",
  dailyRuns_locked: "Completa tutte le piste per sbloccare",
  dailyRuns_lockedShared: "Completa tutte le piste per sbloccare le Corse giornaliere e giocare questa pista condivisa",
  // UNUSED   dailyRun_levelName: "Contratto",
  dailyRun_levelTask: "Prepara la pista alla copertura obiettivo",
  dailyRuns_briefing: "Briefing",
  dailyRuns_target: "Obiettivo",
  dailyRuns_timeLimit: "Tempo",
  dailyRuns_weather_clear: "Cielo sereno",
  dailyRuns_weather_light_snow: "Nevicata leggera",
  dailyRuns_weather_storm: "Condizioni di tempesta",
  dailyRuns_night: "Turno di notte",
  dailyRuns_day: "Turno diurno",
  rank_green: "Verde",
  rank_blue: "Blu",
  rank_red: "Rossa",
  rank_black: "Nera",
  rank_park: "Park",
  share: "Condividi",
  copied: "Link copiato!",
  playSharedSeed: "Corsa condivisa",
  dailyRunBriefingJP: "Questa pista va preparata prima dell'apertura degli impianti. Al lavoro.",
  dailyRunBriefingThierry: "Occhio là fuori — tratti ripidi e neve instabile. Stai attento.",
  dailyRunBriefingMarie: "Stanotte farà un freddo cane. Passa al ristorante a scaldarti, se hai bisogno.",
  dailyRunBriefingEmilie: "Un'altra pista da preparare. Vediamo se batti il mio tempo!"
};

export default it;
